import {gsap} from 'gsap'
import scrollTrigger from 'gsap/ScrollTrigger'
import ScrollToPlugin from 'gsap/ScrollToPlugin'

gsap.registerPlugin(scrollTrigger)
gsap.registerPlugin(ScrollToPlugin)

const anchorSection = () => {

  const mainBody = $('main.content-wrapper')
  const anchorSections = mainBody.find('.anchor-section-js')
  const header = $('.tr-header')
  const navSidebar = $('.tr-sidebar-navigation')
  let timer

  if (anchorSections.length >= 1) {
    anchorSections.each(function () {
      const nameSection = $(this).attr('data-title-anchor') ? $(this).attr('data-title-anchor') : 'Section'
      const nameSectionTitle = $(this).attr('data-title') ? $(this).attr('data-title') : 'Section'
      navSidebar.find('.point-list-sections').append('<li class="point-list-sections__item ' + nameSection + '" data-title-anchor="' + nameSection + '" tabindex="2"><span class="point-cirlce"></span><span class="title">' + nameSectionTitle + '</span></li>')
      header.find('.list-anchor-mob').append('<li class="list-anchor-mob__item ' + nameSection + '" data-title-anchor="' + nameSection + '" tabindex="2"><span class="point-cirlce"></span><span class="title">' + nameSectionTitle + '</span></li>')
      gsap.timeline({
        scrollTrigger: {
          trigger: $(this), markers: false, start: '0 30%', end: '100% 30%', onToggle: (self) => {
            if ($(self.trigger).attr('data-title-anchor')) {
              navSidebar.find('.point-list-sections__item').removeClass('active')
              navSidebar.find('.point-list-sections__item.' + $(self.trigger).attr('data-title-anchor')).addClass('active')
              header.find('.list-anchor-mob__item').removeClass('active')
              header.find('.list-anchor-mob__item.' + $(self.trigger).attr('data-title-anchor')).addClass('active')
            }
          },
        },
      })
    })

    header.find('.list-anchor-mob__item').on('click', function () {
      let anchorLink = $(this).attr('data-title-anchor')
      if (anchorLink) {
        gsap.to(window, {scrollTo: `#${anchorLink}-scroll-js`})
      }
    })
    navSidebar.find('.point-list-sections__item').on('click', function () {
      let anchorLink = $(this).attr('data-title-anchor')
      if (anchorLink) {
        gsap.to(window, {scrollTo: `#${anchorLink}-scroll-js`})
      }
    })

    if (themeVars.isHome || document.body.classList.contains('page-template-landing') || document.body.classList.contains('page-template-proposals')) {
      calcLineanimation(anchorSections, $(window).outerWidth())
      $(window).on('resize', function () {
        clearTimeout(timer)
        timer = setTimeout(() => {
          calcLineanimation(anchorSections, $(this).outerWidth())
        }, 1000)
      })
    }
  }
}

function calcLineanimation(anchorSections, windowWidth) {
  const mainBody = $('main.content-wrapper');
  mainBody.find('.line-animation-left').remove();
  mainBody.find('.line-animation-right').remove();

  const lineAnimLeft = $('<div class="line-animation-left"></div>');
  const isLandingPage = $('body').hasClass('page-template-landing');
  const isProposalTemplate = $('body').hasClass('page-template-proposals');

  let lineAnimRight;
  if (!isLandingPage && !isProposalTemplate) {
    lineAnimRight = $('<div class="line-animation-right"></div>');
    mainBody.append(lineAnimRight);
  }

  mainBody.append(lineAnimLeft);

  let spaceTopFirstSection0Indx = 0, spaceTopFirstSection5Indx = 0, spaceLeft = 50;
  anchorSections.each(function (inx) {
    const positionsAnchors = $(this).find('.point-line-anchor');
    let animLine = lineAnimLeft; // Default to left line

    if ((!isLandingPage && !isProposalTemplate) && inx > 4) {
      animLine = lineAnimRight;
    }

    if (windowWidth <= 1024) spaceLeft = 31;

    let pointLine = $(`<span class="point-line index-${inx}"></span>`);
    animLine.append(pointLine);

    let spaceTop = 0;
    if (positionsAnchors.length >= 1) {
      let positionsAnchorsOffset = positionsAnchors.offset();
      if (inx === 0) {
        animLine.css({left: positionsAnchorsOffset.left - spaceLeft, top: positionsAnchorsOffset.top + 50});
        spaceTopFirstSection0Indx = positionsAnchorsOffset.top;
      } else if (inx === 5 && (!isLandingPage && !isProposalTemplate)) {
        if (windowWidth <= 1024) {
          animLine.css({left: 'initial', right: '40px', top: positionsAnchorsOffset.top + 30});
        } else {
          animLine.css({left: positionsAnchorsOffset.left + 170, top: positionsAnchorsOffset.top + 30});
        }
        spaceTopFirstSection5Indx = positionsAnchorsOffset.top;
      }
      spaceTop = inx <= 4 || isLandingPage || isProposalTemplate ? spaceTopFirstSection0Indx : spaceTopFirstSection5Indx;
      pointLine.css({top: positionsAnchorsOffset.top - spaceTop});
    }

    gsap.timeline({
      scrollTrigger: {
        trigger: $(this),
        markers: false,
        start: isProposalTemplate ? '0 25%' : '0 60%',
        end: isProposalTemplate ? '100% 25%' : '100% 60%',
        onToggle: (self) => {
          const anchorLine = $(self.trigger).find('.point-line-anchor');
          if (inx !== 0 && anchorLine.length >= 1) {
            if (self.isActive) {
              gsap.to(animLine, {height: anchorLine.offset().top - spaceTop});
              gsap.to(animLine.find('.point-line.index-' + inx), {opacity: 1, rotate: -45, scale: 1});
            } else {
              if (anchorSections.length !== inx) {
                gsap.to(animLine.find('.point-line.index-' + inx), {opacity: 0, rotate: -45, scale: 0});
              }
            }
          } else if (inx === 0) {
            gsap.to(animLine, {height: 0});
          }
        },
      },
    });
  });
}

export default anchorSection
